import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=0904d3ca&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0904d3ca')) {
      api.createRecord('0904d3ca', component.options)
    } else {
      api.reload('0904d3ca', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=0904d3ca&", function () {
      api.rerender('0904d3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ED21T45UxwzV/JS/comp/ImgFallback.vue"
export default component.exports